import { Outlet } from "react-router";
import { Row } from "./components/containers";
import { AlignItems, JustifyContent } from "./components/containers/types";
import Navbar from "./components/navbar";
import {
  useChatStore,
  useGeneralStore,
  useNavStore,
  useSocketStore,
  useThemeStore,
} from "./stores";
import "./styles/App.css";
import { FC, useEffect } from "react";
import Popup from "./popup";
import { useAuth, useFetch, usePermanentWidgets, useSwipe } from "./hooks";
import { calcPercent } from "./utils";
import { ChatApi, CustomerApi, TagApi, UserApi } from "./api";
import Alerts from "./alerts";
import { SockStatusIndicator } from "./socket";
import SidePanel from "./components/side-panel";

const App: FC = () => {
  const loading = useAuth(true);
  const theme = useThemeStore((state) => state.theme);

  const connect = useSocketStore((s) => s.connect);
  const close = useSocketStore((s) => s.close);

  useEffect(() => {
    connect();
    return () => {
      close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openNav = useNavStore((s) => s.openNav);

  // on swipe left
  useSwipe(
    (startX) => calcPercent(startX) > 80,
    (startX, currX) => startX - currX > 100,
    openNav
  );

  // on swipe right
  useSwipe(
    (startX) => calcPercent(startX) < 20,
    (startX, currX) => currX - startX > 100,
    () => {}
  );

  // fetch initial data
  useFetch(
    useGeneralStore((s) => s.setTags),
    TagApi.getTags.bind(TagApi)
  );
  useFetch(
    useGeneralStore((s) => s.setCustomers),
    CustomerApi.getAll.bind(CustomerApi)
  );
  useFetch(
    useGeneralStore((s) => s.setUsers),
    UserApi.getUsers.bind(UserApi)
  );
  useFetch(
    useGeneralStore((s) => s.setTopTags),
    TagApi.getTopTags.bind(TagApi)
  );
  useFetch(
    useChatStore((s) => s.setRooms),
    ChatApi.getRooms.bind(ChatApi)
  );

  usePermanentWidgets();

  if (loading) return <></>;
  return (
    <Row
      className="app direction-rtl"
      background={theme.background}
      alignItems={AlignItems.Start}
      justifyContent={JustifyContent.Between}
      gap={16}
    >
      <SockStatusIndicator />
      <Popup />
      <Alerts />
      <Navbar />
      <div
        style={{
          width: "100%",
          height: "100%",
          background: theme.background,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <Outlet />
      </div>
      <SidePanel />
    </Row>
  );
};

export default App;
